export const EbtidaColumns = [
    {
        name: "Ano",
        id: "year",
    },
    {
        name: "Receita Bruta",
        id: "grossRevenue",
    }, 
    {
        name: "Receita Líquida",
        id: "netRevenue",
    }, 
    {
        name: "Lucro antes de IR e CSLL",
        id: "profitBeforeIRCSLL",
    }, 
    {
        name: "Despesas Financeiras",
        id: "financialExpenses",
    }, 
    {
        name: "Receitas Financeiras",
        id: "financialIncome",
    }, 
    {
        name: "Depreciação Lançada no DRE",
        id: "depreciationPostedDRE", 
    }, 
    {
        name: "EBITDA",
        id: "ebtidaResult",
    }
];

export const IndebtednessColumns = [
    {
        name: "Ano",
        id: "year",
    },
    {
        name: "Patrimônio Líquido",
        id: "netWorth",
    }, 
    {
        name: "Ativo Total",
        id: "totalAssets",
    },
    {
        name: "Endividamento a Curto Prazo",
        id: "shortTermIndebtedness",
    }, 
    {
        name: "Endividamento a Longo Prazo",
        id: "longTermIndebtedness",
    }, 
    {
        name: "Total do Endividamento",
        id: "indebtednessResult",
    }
];

export const AvailabilityColumns = [
    {
        name: "Ano",
        id: "year",
    },
    {
        name: "Caixa e Equivalentes",
        id: "cashAndEquivalents",
    },
    {
        name: "Contas a Receber de Clientes",
        id: "billsToReceive",
    },
    { 
        name: "Estoque",
        id: "stock",
    },
    { 
        name: "Imobilizado Líquido",
        id: "netFixedAssets",
    },
    {
        name: "Aplicações Financeiras",
        id: "financialInvestments", 
    },
    {
        name: "Total de Disponibilidade",
        id: "availabilityResult"
    }
];

export const CalcColumns = [
    {
        name: "Financiamento / Faturamento do último ano",
        id: "financingByInvoicing"
    },
    {
        name: "Endividamento a curto prazo/ Total de disponibilidade",
        id: "shortDebtByAvailability"
    },
    {
        name: "Endividamento total/ total de disponibilidade",
        id: "totalIndebtednessByAvailability"
    },
    {
        name: "Endividamento total + Financiamento/ Total de disponibilidade",
        id: "totalIndebtednessFinancingByAvailability"
    },
    {
        name: "Proporção do Financiamento sobre o PL",
        id: "proportionFinancingPL"
    },
    {
        name: "Proporção do financiamento sobre o ativo total da empresa",
        id: "proportionFinancing"
    },
    {
        name: "PL sobre ativo",
        id: "plAssets"
    }
];

export const EbtidaAnalysisColumns = [
    {
        name: "Ebitda (4 vezes)",
        id: "ebtidaFourTimes"
    },
    {
        name: "Valor do Financiamento",
        id: "financialValue"
    },
    {
        name: "Resultado análise ebitda",
        id: "resultEbtidaAnalysis"
    },
    {
        name: "Há impedimentos?",
        id: "hasImpediments"
    }
];

export const GuaranteeColumns = [
    {
        name: "Valor do Imobilizado",
        id: "fixedAssetValue"
    },
    {
        name: "Valor do Financiamento",
        id: "financialValue"
    },
    {
        name: "130% do Financiamento",
        id: "financialValuePercent"
    },
    {
        name: "Garantia necessária é coberta superficialmente pelo imobilizado?",
        id: "immobilizedGuarantee"
    }
];